module.exports = __webpack_public_path__ + "static/media/1.ed329031.webp";